import { ColorVariant } from '../../components'
import { FinancialsTableSettingsType } from '../../components/financials-table'
import { View } from '../../components/line-stacked-bar-chart'
import { RevenueDataEnum } from './types'

export const COOKIE_KEY = 'revenueSettings'

export const DEFAULT_SETTINGS: FinancialsTableSettingsType = {
  [RevenueDataEnum.yoyChange]: false,
  [RevenueDataEnum.yoyChangePct]: false,
  [RevenueDataEnum.sharePct]: false,
  isShowAll: false,
  chartView: View.bars,
}

export const SEGMENT_COLORS = Object.keys(ColorVariant).filter(
  (c) => c !== ColorVariant.gray && c !== ColorVariant.default
) as ColorVariant[]
